/* eslint-disable consistent-return */

import React, { useContext, useState, useEffect } from "react";
import { Pagination } from "@material-ui/lab";
import { Context } from "../../../../../context/Context";
import { getTotalItensRetorno } from "../constants";
import * as Styles from "../styles";

interface Props {
  totalPages: number;
  totalItems: number;
}

export const TablePagination: React.FC<Props> = ({
  totalPages,
  totalItems,
}) => {
  const { filters, setFilters } = useContext(Context);

  const currentPage = filters?.paginationParams?.PaginaAtual || 1;
  const currentItemsPerPage = getTotalItensRetorno(filters);
  const displayCount =
    currentItemsPerPage < totalItems ? currentItemsPerPage : totalItems;

  const handlePagination = (_e: any, page: number) => {
    setFilters({
      ...filters,
      paginationParams: { ...filters.paginationParams, PaginaAtual: page },
    });
  };

  // "Ir para página" input com debounce
  const [pageInput, setPageInput] = useState(String(currentPage));

  useEffect(() => {
    setPageInput(String(currentPage));
  }, [currentPage]);

  useEffect(() => {
    const parsed = parseInt(pageInput, 10);
    if (!pageInput || Number.isNaN(parsed)) return;
    const clamped = Math.min(Math.max(parsed, 1), totalPages || 1);
    if (clamped === currentPage) return;
    const timer = setTimeout(() => {
      setFilters({
        ...filters,
        paginationParams: {
          ...filters.paginationParams,
          PaginaAtual: clamped,
        },
      });
    }, 600);
    return () => clearTimeout(timer);
  }, [pageInput]);

  return (
    <Styles.ContainerPagination>
      <Styles.Arrows>
        <Pagination
          color="standard"
          count={totalPages}
          page={currentPage}
          onChange={handlePagination}
          showFirstButton
          size="small"
          variant="outlined"
          shape="round"
          showLastButton
        />
      </Styles.Arrows>
      <Styles.ShowTotalText>
        Exibindo {displayCount} lead(s) de {totalItems}
      </Styles.ShowTotalText>
      <Styles.Arrows>
        <small style={{ fontFamily: "Inter" }}>Ir para página</small>
        <input
          type="number"
          min={1}
          max={totalPages || 1}
          value={pageInput}
          onChange={(e) => setPageInput(e.target.value)}
          style={{
            width: 52,
            height: 32,
            marginLeft: 8,
            border: "1px solid #c6ccd7",
            borderRadius: 16,
            textAlign: "center",
            fontFamily: "Inter",
            fontSize: 13,
            color: "#46505a",
            outline: "none",
            padding: "0 8px",
          }}
        />
        <small style={{ fontFamily: "Inter", marginLeft: 16 }}>
          Itens por página
        </small>
        <Styles.Select
          displayEmpty
          inputProps={{ "aria-label": "Without label" }}
          color="secondary"
          variant="outlined"
          labelId="pages"
          id="pages"
          value={currentItemsPerPage}
          label="Pages"
          onChange={(event) => {
            const newItemsPerPage = Number(event.target.value);
            const newTotalPages = Math.ceil(totalItems / newItemsPerPage);
            const shouldResetToPage1 = currentPage > newTotalPages;
            setFilters({
              ...filters,
              paginationParams: {
                ...filters.paginationParams,
                TotalItensRetorno: newItemsPerPage,
                PaginaAtual: shouldResetToPage1 ? 1 : currentPage,
              },
            });
          }}
        >
          <Styles.MenuItem value={10}>10</Styles.MenuItem>
          <Styles.MenuItem value={20}>20</Styles.MenuItem>
          <Styles.MenuItem value={50}>50</Styles.MenuItem>
          <Styles.MenuItem value={100}>100</Styles.MenuItem>
        </Styles.Select>
      </Styles.Arrows>
    </Styles.ContainerPagination>
  );
};
